import React from 'react';

import { shouldMockFachinteressent } from 'components/CardCollectionMyData/MyDataTestSetup';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';

import { STORAGE_KEY } from 'global/constants';

import { isProduction } from 'utils/StageUtils';

import './FormTestingBanner.sass';

export const MyDataTestingBanner = () => {
  const toggleMockFachinteressent = () => {
    localStorage.setItem(STORAGE_KEY.MOCK_FACHINTERESSENT, !shouldMockFachinteressent);
    window.location.reload();
  };

  if (isProduction()) {
    return null;
  }

  return (
    <div className="test-container">
      <div className="test-alert-container">
        <LabelCheckbox
          tooltipText="Simuliert ein Fachinteressent-Konto, indem bEintragungAls und bEintragungGasAls auf ID 4 gesetzt werden. Die Seite wird neu geladen, damit die Meine-Daten-Ansicht getestet werden kann."
          name="mockFachinteressent"
          id="mockFachinteressent"
          testId="mockFachinteressent"
          value={shouldMockFachinteressent}
          onChange={toggleMockFachinteressent}
          label="Als Fachinteressent simulieren?"
        />
        {shouldMockFachinteressent && (
          <div>
            <span className="test-alert-bold">Aktiv: </span>
            bEintragungAls / bEintragungGasAls werden mit ID 4 mockiert
          </div>
        )}
      </div>
    </div>
  );
};
